import { NgModule } from '@angular/core';
import { ConfirmDirective } from './directives/confirm.directive';
import { ConfirmationModalComponent } from './components/confirmation-modal.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ConfirmDirective, ConfirmationModalComponent],
  exports: [ConfirmDirective, ConfirmationModalComponent],
  imports: [TranslateModule],
  entryComponents: [ConfirmationModalComponent],
})
export class ConfirmationModule {}
